import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

function EditPowerOfficials() {
  const { genofficial_id, power_id, plantName } = useParams(); // get both IDs
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    genofficial_designation: "",
    genofficial_name: "",
    genofficial_email: "",
    genofficial_phone: "",
  });

  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(true);

  // Fetch existing official
  useEffect(() => {
    const fetchOfficial = async () => {
      try {
        const res = await axios.get(
          `https://backend-zkgn.onrender.com/api/powergen_officials/${genofficial_id}`
        );
        setFormData(res.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching official:", error.message);
        setLoading(false);
      }
    };
    fetchOfficial();
  }, [genofficial_id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validate = () => {
    let tempErrors = {};
    let isValid = true;

    if (!formData.genofficial_designation.trim()) {
      tempErrors.genofficial_designation = "Designation is required.";
      isValid = false;
    }
    if (!formData.genofficial_name.trim()) {
      tempErrors.genofficial_name = "Official's Name is required.";
      isValid = false;
    }
    if (formData.genofficial_email && !/\S+@\S+\.\S+/.test(formData.genofficial_email)) {
      tempErrors.genofficial_email = "Enter a valid email address.";
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      await axios.put(
        `https://backend-zkgn.onrender.com/api/powergen_officials/update/${genofficial_id}`,
        formData
      );
      setSuccessMessage("Power Official Updated Successfully!");

      setTimeout(() => {
        setSuccessMessage("");
        // Redirect to officials list of the plant
        navigate(`/powergenplant-officials/${plantName}/${power_id}`);
      }, 2000);
    } catch (error) {
      console.error("Error updating official:", error.message);
    }
  };

  if (loading) return <div className="text-center my-5">Loading...</div>;

  return (
    <div className="container my-5">
      <h4 className="mb-4 text-center">Edit Power Plant Official</h4>

      {successMessage && (
        <div className="alert alert-success text-center">{successMessage}</div>
      )}

      <form onSubmit={handleSubmit} className="shadow p-4 rounded bg-light">
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label">Designation</label>
            <input
              type="text"
              className="form-control"
              name="genofficial_designation"
              value={formData.genofficial_designation}
              onChange={handleChange}
            />
            {errors.genofficial_designation && (
              <small className="text-danger">{errors.genofficial_designation}</small>
            )}
          </div>

          <div className="col-md-6">
            <label className="form-label">Official's Name</label>
            <input
              type="text"
              className="form-control"
              name="genofficial_name"
              value={formData.genofficial_name}
              onChange={handleChange}
            />
            {errors.genofficial_name && (
              <small className="text-danger">{errors.genofficial_name}</small>
            )}
          </div>

          <div className="col-md-6">
            <label className="form-label">Official's Email</label>
            <input
              type="email"
              className="form-control"
              name="genofficial_email"
              value={formData.genofficial_email}
              onChange={handleChange}
            />
            {errors.genofficial_email && (
              <small className="text-danger">{errors.genofficial_email}</small>
            )}
          </div>

          <div className="col-md-6">
            <label className="form-label">Phone Number</label>
            <input
              type="text"
              className="form-control"
              name="genofficial_phone"
              value={formData.genofficial_phone}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="text-center mt-4">
          <button type="submit" className="btn btn-primary px-4">
            Update Power Official
          </button>
        </div>
      </form>
    </div>
  );
}

export default EditPowerOfficials;
